export const CRYSTAL_RARITY_COLORS = {
    Bronze: '#A75F2A',
    Silver: '#BCBCBC',
    Gold: '#FFB700',
    Lucky: '#1AC152',
    Royal: '#1FAFC3',
    Nova: '#DA2223',
    Diamond: '#BC3EA4',
};

// Индекс 0 — самая высокая редкость (первый пресет)
export const CRYSTAL_RARITY_NAMES_BY_COUNT = {
    3: ['Gold', 'Silver', 'Bronze'],
    5: ['Royal', 'Lucky', 'Gold', 'Silver', 'Bronze'],
    7: ['Diamond', 'Nova', 'Royal', 'Lucky', 'Gold', 'Silver', 'Bronze'],
};

export function getCrystalRarityTiers(total) {
    const names = CRYSTAL_RARITY_NAMES_BY_COUNT[total] || CRYSTAL_RARITY_NAMES_BY_COUNT[7];
    return names.map((name) => ({ name, color: CRYSTAL_RARITY_COLORS[name] }));
}

export function getCrystalRarityTier(index, total) {
    const tiers = getCrystalRarityTiers(total);
    return tiers[index] ?? { name: `Place ${index + 1}`, color: '#DEC315' };
}

export function getCrystalRarityColorMap(total) {
    return getCrystalRarityTiers(total).map(({ color }) => ({
        border: color,
        text: color,
    }));
}
